import { render } from "./emission-detail.vue?vue&type=template&id=31be8ab4&scoped=true"
import script from "./emission-detail.vue?vue&type=script&lang=js"
export * from "./emission-detail.vue?vue&type=script&lang=js"

import "./emission-detail.vue?vue&type=style&index=0&id=31be8ab4&scoped=true&lang=css"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31be8ab4"]])

export default __exports__